<template>
  <div class="card">
    <IconLeague class="icon-league" :class="{ show: icons }" />
    <img class="icon-coin" :class="{ show: icons }" src="../../assets/images/icon-lp-coin.png">
    <img class="icon-python" :class="{ show: icons }" src="../../assets/images/icon-python.png">
    <div class="label-holder">
      <span class="label-accent">
        {{ options.labelText }}
      </span>
    </div>
    <div class="regular-price">
      {{ options.currencySign }}{{ options.regularPrice }}
    </div>
    <br>
    <div class="discounted-price">
      {{ options.currencySign }}{{ options.discountedPrice }}
      <span> {{ options.discountedPriceCharge }} </span>
    </div>
    <div class="subtitle">
      {{ options.billedText }}
    </div>
    <Countdown
      v-if="options.countdown" :end-date="endDate" :countdown-hide-days="countdownHideDays"
      v-on="$listeners"
    />
    <button class="btn-primary btn-lg" :class="options.subscribeClass" @click="emitSubscribe">
      {{ options.buttonText }}
    </button>
  </div>
</template>

<script>
import IconLeague from '../../assets/svg/icon-league.svg?vue-component';

export default {
  components: {
    Countdown: async () => import('./Countdown'),
    IconLeague,
  },
  props: {
    options: { type: Object, default: () => {}, required: true },
    endDate: { type: Date, default: () => new Date(), required: false },
    countdownHideDays: Boolean,
    icons: { type: Boolean, required: false },
  },
  methods: {
    emitSubscribe() {
      this.$emit('subscribe', this.options.promoPlanType);
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  padding: var(--spacing-36);
  position: relative;
  z-index: 1;

  .icon-league {
    display: none;
    position: absolute;
    left: 256px;
    top: -86px;
  }

  .icon-python {
    width: 107px;
    height: 109px;
    display: none;
    position: absolute;
    left: -145px;
    top: 190px;
  }

  .icon-coin {
    width: 150px;
    display: none;
    position: absolute;
    right: -26px;
    bottom: -104px;
  }

  .show {
    display: block;
  }

  .label-accent {
    display: inline-block;
    max-width: unset;
    max-height: unset;
    font-size: 20px;
    padding: 8px 16px;
  }

  .regular-price {
    display: inline-block;
    font-size: 30px;
    margin-top: var(--spacing-12);
    margin-bottom: var(--spacing-8);
    color: var(--main-light-shade-4);
    position: relative;

    &:before {
      content: '';
      top: 50%;
      left: 0;
      right: 0;
      position: absolute;
      transform: translateY(-50%);
      height: 3px;
      width: 100%;
      background-color: var(--main-light-shade-4);
    }
  }

  .discounted-price {
    font-size: 72px;
    font-weight: 500;
    color: var(--main-dark-shade-0);
    position: relative;
    display: inline-block;

    span {
      margin-left: -10px;
      font-size: 21px;
    }
  }

  .subtitle {
    color: var(--main-dark-light-4);
    margin-top: var(--spacing-12);
    margin-bottom: var(--spacing-24);
  }

  .countdown {
    margin-bottom: var(--spacing-24);
  }

  .btn-primary {
    width: 100%;
  }
}

@include bp($bp-mobile) {
  .card {
    margin-top: var(--spacing-40);

    .label-accent {
      font-size: 18px;
      max-width: 190px;
    }

    .regular-price {
      font-size: 24px;
    }

    .discounted-price {
      font-size: 58px;
    }

    .subtitle {
      font-size: 18px;
    }

    .btn-primary {
      max-width: 280px;
    }
  }
}
</style>
